import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import Button from "./Button";
import Link from "next/link";
import NavItemLink from "./NavItemLink";
import NavItemWithDropdown from "./NavItemWithDropdown";
import React from "react";
import SmallCaps from "./SmallCaps";
import Text from "./Text";
import { useAppContext } from "./AppContext";

function BrandNav({ brand, navItems }) {
  const { setMobBrandMenuOpen } = useAppContext();

  const href = `/${brand.slug}`;

  return (
    <BoxWithGutter
      position="relative"
      bg="darkGrey"
      borderTop="1px solid"
      borderBottom="1px solid"
      borderColor="darkGrey"
      height={60}
      color="white"
      display="flex"
      px={[20, null, 80, null]}
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent={["space-between", null, "flex-start", null]}
        height="100%"
        width="100%"
      >
        <Link href={href} passHref>
          <Box as="a" transition="opacity 200ms" hover="opacity: 0.5">
            <SmallCaps color="white">{brand.name}</SmallCaps>
          </Box>
        </Link>

        <Box
          pl={40}
          height="100%"
          display={["none", null, "flex", null]}
          alignItems="center"
        >
          <Box
            borderLeft="1px solid"
            borderLeftColor="lightGrey"
            height={14}
            mr={-10}
          />
          {navItems.map((item, index) => {
            if (item.children.length) {
              return (
                <NavItemWithDropdown
                  key={item.slug}
                  color="white"
                  item={item}
                  firstOfType={index === 0}
                  lastOfType={index === navItems.length - 1}
                  dropdownBg="black"
                  dropdownColor="white"
                />
              );
            } else {
              return (
                <NavItemLink
                  key={item.slug}
                  color="white"
                  item={item}
                  firstOfType={index === 0}
                />
              );
            }
          })}
        </Box>
        <Button
          height="18px"
          width="18px"
          borderRadius="100%"
          border="2px solid"
          borderColor="lightGrey"
          display={["flex", null, "none", null]}
          justifyContent="center"
          alignItems="center"
          onClick={() => {
            setMobBrandMenuOpen(true);
          }}
        >
          <Text
            fontWeight={700}
            color="lightGrey"
            fontSize={17}
            lineHeight={1}
            mt="-1px"
          >
            +
          </Text>
        </Button>
      </Box>
    </BoxWithGutter>
  );
}

export default BrandNav;
